export default __webpack_public_path__ + "static/media/img-gtl-abp@3x.3cfc7ce5.png";